import {createStore,applyMiddleware} from 'redux'
import {powerQueryReducer} from './Reducers/PowerQuery';

import middleware from './middleware'

export default createStore(powerQueryReducer, applyMiddleware(...middleware))